<template>
  <v-theme-provider dark>
    <section id="hero-alt">
      <video-background
        class="video"
        :poster="require('@/assets/featured-1.png')"
        style="max-height: 600px; height: 50vh; z-index: 1;"
        overlay="linear-gradient(45deg,#2a4ae430,#fb949e6b)"
      >
        <v-row
          v-if="title"
          align="center"
          class="ma-0 fill-height text-center"
          justify="center"
        >
          <v-col cols="12">
            <base-heading
              :title="title"
              space="2"
              weight="500"
            />

            <base-divider
              color="primary"
              dense
            />

            <base-title
              space="0"
              title="FOLLOW US FOR UPDATES"
              class="justify-center pa-0"
            />

            <!-- <v-avatar
              color="black"
              size="56"
              class="base-avatar__avatar"
              v-bind="$attrs"
              v-on="$listeners"
            >
              <base-img
                width="75"
                height="75"
                :src="require(`@/assets/mask.png`)"
              >
              </base-img>
            </v-avatar> -->
          </v-col>
        </v-row>
      </video-background>

      <v-row
        class="ma-4 fill-height text-center"
        justify="center"
      >
        <v-btn
          color="#4267B2"
          width="300"
          outlined
        >
          Facebook
        </v-btn>
      </v-row>

      <v-row
        class="ma-4 fill-height text-center"
        justify="center"
      >
        <v-btn
          color="#E1306C"
          width="300"
          outlined
          href="https://instagram.com/maskio.io"
        >
          Instagram
        </v-btn>
      </v-row>

      <v-row
        class="ma-4 fill-height text-center"
        justify="center"
      >
        <v-btn
          color="#69C9D0"
          width="300"
          outlined
        >
          TikTok
        </v-btn>
      </v-row>
    </section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionHeroAlt2',

    provide: {
      heading: { align: 'center' },
    },

    data: () => ({
      title: 'Wear Hue',
    }),
  }
</script>
